import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterAndTransform',
  standalone: true,
  pure: true
})
export class FilterAndTransformPipe implements PipeTransform {
  transform(items: any[], section: any, parseStringToArray: (str: string) => any[]): any[] {
    return items
      .filter((item) => item.section === section.title) // Filtra per sezione
      .map((item) => {
        // Applica la logica su field_options
        if (item.field_options) {
          if (!Array.isArray(item.field_options)) {
            item.field_options = parseStringToArray(item.field_options.toString());
          }
        }
        return item;
      });
  }
}
